import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'

// 领取奖励
export const blind_box_collect_reward = createAsyncThunk(
  '/live/gift/blind_box_collect_reward',
  async (blindBoxId: number, store: any) => {
    const resp = await http.post('/live/gift/blind_box_collect_reward', {
      ...store.getState().env.deviceinfo,
      blind_box_id: blindBoxId,
    })
    return resp.data.data
  }
)

const initialState: {
  isReceive: boolean
} = {
  isReceive: false,
}

export const BlindBoxModalSlice = createSlice({
  name: 'BlindBoxModal',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(blind_box_collect_reward.fulfilled, (state, action) => {
      // Object.assign(state, {collect: {...action.payload}})
    })
  },
})

export const useBlindBoxModal = () =>
  useSelector((store) => store.BlindBoxModal)

export default BlindBoxModalSlice.reducer
export const BlindBoxModalActions = BlindBoxModalSlice.actions
